import React from "react";
import styles from "../HealthChat.module.css";

/* ─── SVG Icons ─────────────────────────────────────────────────────────── */
// Star icon for the top message bubble
const StarIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="#7C4DFF" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);

/* ─── Copy ───────────────────────────────────────────────────────────────── */
const COPY = {
  en: {
    bubbleMsg: "Please review your appointment details before we proceed.",
    doctorLabel: "Doctor",
    doctorName: "Dr. Neha Sharma",
    doctorRole: "Gynecologist",
    dateLabel: "Date",
    timeLabel: "Time",
    typeLabel: "Visit type",
    locationLabel: "Location",
    feeLabel: "Consultation fee",
    confirmBtn: "Confirm & continue",
  }
  // ... hi and te translations would be updated similarly
};

export default function ConfirmAppointmentScreen({ lang = "en", apptData = {}, onConfirm,onBack }) {
  const c = COPY[lang] || COPY.en;

  // Formatting date to match image: Tuesday, 21 May 2024
  const formattedDate = apptData.date 
    ? new Date(apptData.date).toLocaleDateString("en-GB", { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
    : "Tuesday, 21 May 2024";

  return (
    <div className={styles.bookingWrapper}>
      {/* AI Message Bubble */}
      <button className={styles.selectCareBack} onClick={onBack}>
        ← Back
      </button>
      <div className={styles.messageBubbleRow}>
        <img
          src="/images/chatbot.svg"
          alt="Chatbot"
          width={52}
          height={52}
          className={styles.avatar}
        />
        <div className={styles.messageBubble}>
          {c.bubbleMsg}
          <span className={styles.timeStamp}>10:32 AM</span>
        </div>
      </div>

      {/* Appointment Card */}
      <div className={styles.detailsCard}>
        {/* Doctor Section */}
        <div className={styles.detailItem}>
          <label className={styles.detailLabel}>{c.doctorLabel}</label>
          <div className={styles.doctorInfoRow}>
            <img 
              src="/Home/5section-2.svg" 
              alt="Doctor" 
              className={styles.doctorAvatar} 
            />
            <div className={styles.doctorText}>
              <div className={styles.doctorNameMain}>{c.doctorName}</div>
              <div className={styles.doctorSubRole}>{c.doctorRole}</div>
            </div>
          </div>
        </div>

        {/* Vertical List of Details */}
        <div className={styles.detailItem}>
          <label className={styles.detailLabel}>{c.dateLabel}</label>
          <div className={styles.detailValue}>{formattedDate}</div>
        </div>

        <div className={styles.detailItem}>
          <label className={styles.detailLabel}>{c.timeLabel}</label>
          <div className={styles.detailValue}>{apptData.time || "10:00 AM"}</div>
        </div>

        <div className={styles.detailItem}>
          <label className={styles.detailLabel}>{c.typeLabel}</label>
          <div className={styles.detailValue}>{apptData.apptType === "inperson" ? "In-clinic visit" : "Online Consultation"}</div>
        </div>

        <div className={styles.detailItem}>
          <label className={styles.detailLabel}>{c.locationLabel}</label>
          <div className={styles.detailValue}>
            Avexa Women's Health Clinic<br />
            Bangalore, Karnataka
          </div>
        </div>

        <div className={styles.detailItem}>
          <div className={styles.feeRow}>
            <label className={styles.detailLabel}>{c.feeLabel}</label>
            <div className={styles.feeValue}>₹800</div>
          </div>
        </div>
      </div>

      {/* Primary Action Button */}
      <button className={styles.visitModelContinueBtn} onClick={onConfirm}>
        {c.confirmBtn}
      </button>
    </div>
  );
}